import type { UIStrings } from './en';

export const he: UIStrings = {
  'site.title': 'DopeJs — כלים בקוד פתוח לפיתוח עם סוכנים',
  'site.description':
    'DopeJs בונה כלים בקוד פתוח לפיתוח בעידן הבינה המלאכותית: סביבות ריצה לסוכנים, סוכני קוד בטרמינל, כלים לניהול סביבות CLI ומנועי רינדור Canvas.',

  'nav.projects': 'פרויקטים',
  'nav.about': 'אודות',
  'nav.github': 'GitHub',
  'nav.skip': 'דלג לתוכן',
  'nav.theme': 'ערכת נושא',
  'nav.language': 'שפה',

  'hero.eyebrow': 'קוד פתוח · פיתוח גלוי',
  'hero.title': 'כלים לפיתוח בעידן הבינה המלאכותית.',
  'hero.body':
    'DopeJs היא קבוצה קטנה של פרויקטים בקוד פתוח סביב שאלה אחת: איך נראית התוכנה שאתם משתמשים בה כל יום כשסוכנים הם חלק מהתהליך? סביבות ריצה לסוכנים, סוכני קוד בטרמינל, כלים לסביבות CLI ומנועי רינדור Canvas — הכול מפותח בגלוי.',
  'hero.cta.projects': 'לצפייה בפרויקטים',
  'hero.cta.github': 'צפייה ב-GitHub',
  'hero.count': 'פרויקטים',

  'projects.title': 'פרויקטים',
  'projects.repo': 'מאגר',
  'projects.homepage': 'אתר',
  'projects.install': 'התקנה',
  'projects.copy': 'העתק',
  'projects.copied': 'הועתק',
  'projects.details': 'פרטים',

  'status.stable': 'שוחרר',
  'status.active': 'בפיתוח פעיל',
  'status.early': 'שלב מוקדם — לא מיועד לייצור',
  'status.design': 'שלב תכנון',

  'project.back': 'כל הפרויקטים',
  'project.overview': 'סקירה',
  'project.highlights': 'מה זה עושה',
  'project.getStarted': 'איך מתחילים',
  'project.requirements': 'דרישות',
  'project.facts': 'במבט מהיר',
  'project.facts.status': 'סטטוס',
  'project.facts.languages': 'שפות',
  'project.facts.license': 'רישיון',
  'project.facts.noLicense': 'עדיין אין',
  'project.links': 'קישורים',
  'project.issues': 'Issues',
  'project.releases': 'Releases',
  'project.prev': 'הקודם',
  'project.next': 'הבא',

  'about.title': 'אודות DopeJs',
  'about.body':
    'כל מה שכאן מפותח בגלוי, ב-GitHub. issues ו-pull requests יתקבלו בברכה בכל מאגר — וכך גם דיווחים כנים על משהו שעדיין לא עובד. כמה מהפרויקטים נמצאים לפני שחרור מתוך בחירה, ובמקרים כאלה הפרויקט אומר זאת במפורש.',
  'about.cta': 'עקבו אחרי הארגון ב-GitHub',

  'footer.built': 'נבנה עם React ו-Vite. הקוד ב-GitHub.',
  'footer.rights': 'DopeJs',
  'footer.translations': 'התרגומים נוצרו אוטומטית — תיקונים יתקבלו בברכה.',
};
